import { useAppSelector } from '@/shared/hooks';
import { ImageConfig } from 'konva/lib/shapes/Image';
import { Image, KonvaNodeEvents } from 'react-konva';
import useImage from 'use-image';

export function BgImage({
  ...props
}: Omit<ImageConfig, 'image'> & KonvaNodeEvents) {
  const bgImage = useAppSelector(
    (state) =>
      state.collection.framesList[state.collection.selectedFrameIndex]
        ?.backgroundImage ||
      state.collection.backgroundImage ||
      ''
  );
  const opacity = useAppSelector((state) => state.collection.opacity);
  const [image] = useImage(bgImage);

  if (!bgImage) return;

  return (
    <Image
      width={1920 / 2}
      height={1080 / 2}
      fit="contain"
      {...props}
      opacity={opacity}
      image={image}
    />
  );
}
